'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dUsers$002dPage$0024 from "./presto.-List-Users-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002477 from "./presto.-Presto-Router$$anon$77.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$76() {
  this.bmd = null;
  this.bm5 = null;
  this.bm6 = false;
  this.bme = null;
  this.bmf = false;
  this.bmi = null;
  this.bmb = null;
  this.bmc = false;
  this.bm7 = null;
  this.bm8 = false;
  this.bm9 = null;
  this.bma = false;
  this.bmg = false;
  this.bmh = false;
  this.bmd = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bmi = "ListUsersPage";
}
export { $c_Lpresto_PrestoRouter$$anon$76 as $c_Lpresto_PrestoRouter$$anon$76 };
$p = $c_Lpresto_PrestoRouter$$anon$76.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$76;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$76() {
}
export { $h_Lpresto_PrestoRouter$$anon$76 as $h_Lpresto_PrestoRouter$$anon$76 };
$h_Lpresto_PrestoRouter$$anon$76.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bmd;
});
$p.M = (function() {
  if ((!this.bm6)) {
    this.bm5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bm6 = true;
  }
  return this.bm5;
});
$p.O = (function() {
  if ((!this.bmf)) {
    this.bme = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bmf = true;
  }
  return this.bme;
});
$p.E = (function() {
  return this.bmi;
});
$p.t = (function() {
  if ((!this.bmc)) {
    this.bmb = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bmc = true;
  }
  return this.bmb;
});
$p.N = (function() {
  if ((!this.bm8)) {
    this.bm7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bm8 = true;
  }
  return this.bm7;
});
$p.Q = (function() {
  if ((!this.bma)) {
    this.bm9 = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002477.$c_Lpresto_PrestoRouter$$anon$77();
    this.bma = true;
  }
  return this.bm9;
});
$p.v = (function() {
  if ((!this.bmh)) {
    this.bmg = false;
    this.bmh = true;
  }
  return this.bmg;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee521) => ((p) => \u03b4scrutinee521))($j_presto$002e$002dList$002dUsers$002dPage$0024.$m_Lpresto_ListUsersPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$76 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$76, "presto.PrestoRouter$$anon$76", ({
  OT: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$76 as $d_Lpresto_PrestoRouter$$anon$76 };
//# sourceMappingURL=presto.-Presto-Router$$anon$76.js.map
